export const RSA_STORE_SERVER_KEY = (sPublic) => ({
  type: 'RSA_STORE_SERVER_KEY',
  payload: {
    sPublic,
  },
});
